
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M13.564 1.039a.75.75 0 01.683-.096 14.497 14.497 0 018.859 8.86.75.75 0 01-.708.999h-4.623a.75.75 0 01-.73-.578c-.403-1.712-1.508-2.817-3.22-3.22a.75.75 0 01-.577-.73V1.65a.75.75 0 01.316-.612zm-2.54 2.363a9.525 9.525 0 109.525 9.524.75.75 0 00-.75-.75H15.85a.75.75 0 00-.75.75 4.076 4.076 0 11-4.076-4.076.75.75 0 00.75-.75V4.152a.75.75 0 00-.75-.75z"}})])
          )
        }
      }
    